<template>
	<Modal v-model="modalMsg" width="360" :closable="false" :mask-closable="false" class-name="msg-modal">
		<!-- <p slot="header" style="text-align:center">
			<span>短信营销</span>
		</p> -->
		<div style="text-align:center;font-size: 14px;">
			<p>
				为了您能及时收到最新优惠+会员活动+新品上市等信息，我们建议您开启短信通知。
			</p>
		</div>
		<div slot="footer" class="footer">
			<Button size="large" long @click="cancel">
				取消
			</Button>
			<Button type="error" size="large" long @click="agree">
				开启
			</Button>
		</div>
		<div slot="footer" class="tipBox">
			<Checkbox v-model="isRemindAgain" @on-change="onRemind"> 下次不再提醒</Checkbox>
		</div>
	</Modal>
</template>

<script>
import { Toast } from 'vant';
export default {
	data() {
		return {
			modalMsg: false,
			isRemindAgain: false,
		};
	},
	methods: {
		cancel() {
			this.messageAuthorize({ isPersonalizedAgree: 0, isRemindAgain: this.isRemindAgain ? 1 : 0 });
		},
		agree() {
			this.messageAuthorize({ isPersonalizedAgree: 1, isRemindAgain: this.isRemindAgain ? 1 : 0 });
		},
		onRemind(val) {
			this.isRemindAgain = val == true ? 1 : 0;
			this.messageAuthorize({ isRemindAgain: val == true ? 1 : 0 });
		},
		async messageAuthorize(params) {
			try {
				let { data: result } = await this.$post('modifyPersonalized', params);
				if (result.errCode !== '00') return Toast(result.errMsg);
				let personalizedShowTag = localStorage.getItem('personalizedShowTag');
				if (personalizedShowTag) {
					localStorage.removeItem('personalizedShowTag');
				}
				this.modalMsg = false;
				this.$emit('refreshInfo');
			} catch (err) {
				console.log(err);
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.msg-modal {
	.footer {
		display: flex;
	}
}

/deep/ .ivu-modal-wrap {
	display: flex;
	align-items: center;
	justify-content: center;
	.ivu-modal {
		top: 0;
	}
	.ivu-modal-header {
		border-bottom: none !important;
	}
	.ivu-modal-footer {
		border-top: none !important;
	}
}
.tipBox {
	display: flex;
	align-items: center;
	justify-content: center;
	padding: 15px 0 0;
	font-size: 16px;
}
</style>
